module.exports = __webpack_public_path__ + "5bced4c20ae1214fca8bb0d7d0adc48c.png";